import { render, staticRenderFns } from "./Yzxml.vue?vue&type=template&id=54c65d38&scoped=true&"
import script from "./Yzxml.vue?vue&type=script&lang=js&"
export * from "./Yzxml.vue?vue&type=script&lang=js&"
import style0 from "./Yzxml.vue?vue&type=style&index=0&id=54c65d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c65d38",
  null
  
)

export default component.exports